/*
 * Define a form page to display a list of Programs.
 * Include the Other input option.
 * The list of programs (choices) must be provided by the calling function.
 */
import css from './pages.module.css'
import { otherChoicePage } from './choicePage'

export const programPage = propOverrides => {
  const props = {
    pageId: 'hhs_program_page',
    fieldName: 'hhs_program',
    choices: [],
    label: 'Which program does this relate to?',
    className: css.choices,
    labelClassName: css.largeLabel,
    fieldNameOther: 'hhs_program_other',
    labelOther: 'Please enter the related program',
    ...propOverrides
  }

  return otherChoicePage({ ...props })
}
